export const CALENDAR_KIND_CHIP_CLASS = {
  event: 'bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300',
  meeting: 'bg-fuchsia-100 text-fuchsia-700 dark:bg-fuchsia-950 dark:text-fuchsia-300',
  'org-event': 'bg-indigo-100 text-indigo-700 dark:bg-indigo-950 dark:text-indigo-300',
  holiday: 'bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-300',
  task: 'bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300',
  note: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300',
  schedule: 'bg-slate-100 text-slate-700 dark:bg-slate-900 dark:text-slate-300',
  'pms-task': 'bg-violet-100 text-violet-700 dark:bg-violet-950 dark:text-violet-300',
  'pms-project': 'bg-cyan-100 text-cyan-700 dark:bg-cyan-950 dark:text-cyan-300',
} as const;

export const CALENDAR_KIND_CARD_CLASS = {
  event: 'bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900',
  meeting: 'bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200 dark:bg-fuchsia-950 dark:text-fuchsia-300 dark:border-fuchsia-900',
  task: 'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900',
  note: 'bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-900',
  'org-event': 'bg-indigo-100 text-indigo-700 border-indigo-200 dark:bg-indigo-950 dark:text-indigo-300 dark:border-indigo-900',
  holiday: 'bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-950 dark:text-rose-300 dark:border-rose-900',
  schedule: 'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-900 dark:text-slate-300 dark:border-slate-800',
  'pms-task': 'bg-violet-100 text-violet-700 border-violet-200 dark:bg-violet-950 dark:text-violet-300 dark:border-violet-900',
  'pms-project': 'bg-cyan-100 text-cyan-700 border-cyan-200 dark:bg-cyan-950 dark:text-cyan-300 dark:border-cyan-900',
} as const;

export const CALENDAR_SURFACE_CLASS = {
  popupCard:
    'relative z-10 w-full max-w-xl rounded-3xl border border-border bg-card p-5 sm:p-7 shadow-[0_20px_60px_-20px_rgba(15,23,42,0.45)] animate-in zoom-in-95 slide-in-from-bottom-3 duration-300 ease-out',
  subtlePanel: 'rounded-2xl border border-border bg-muted/40 p-4',
  iconButton:
    'rounded-xl border border-border p-2 text-muted-foreground transition-all hover:bg-secondary hover:text-foreground active:scale-95',
  outlineButton:
    'rounded-xl border border-border px-4 py-2 text-sm font-semibold text-foreground transition-colors hover:bg-secondary',
  metaText: 'text-xs font-medium text-muted-foreground',
} as const;

export const CALENDAR_YEAR_DATE_CELL_CLASS = {
  base: 'relative mx-auto flex h-8 w-8 items-center justify-center rounded-full text-[11px] font-medium transition-all duration-200',
  selected: 'z-10 bg-gradient-to-br from-[#5B6CF6] to-[#8B5CF6] font-bold text-white',
  today: 'font-bold text-[#5B47E8] ring-2 ring-inset ring-[#5B6CF6]/60 dark:text-[#8B7CFF] dark:ring-[#8B7CFF]/60',
  currentMonthIdle: 'text-slate-700 dark:text-slate-200',
  currentMonthHover: 'hover:bg-[#EEF2FF] hover:text-[#5B47E8] dark:hover:bg-[#1C1F3F] dark:hover:text-[#8B7CFF]',
  outsideMonth: 'text-slate-300 dark:text-slate-600',
  selectedDot: 'bg-white',
} as const;
